import { render, staticRenderFns } from "./resett.vue?vue&type=template&id=0e6b2bdb&scoped=true&"
import script from "./resett.vue?vue&type=script&lang=js&"
export * from "./resett.vue?vue&type=script&lang=js&"
import style0 from "./resett.vue?vue&type=style&index=0&id=0e6b2bdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6b2bdb",
  null
  
)

export default component.exports